import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  TableContainer,
  Text,
  Flex,
  Spinner,
  Select,
  Icon,
  InputRightElement,
  InputGroup,
  Input,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaPlay, FaSearch } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { componentState } from "../../../atoms/componentState";
import Pagination from "../../../defaultComponents/pagination";
import { useRecoilState, useSetRecoilState } from "recoil";
import moment from "moment";
import SalesListAPI from "../../../services/SalesListApi";
import {
  basicInfo,
  ClientInterface,
  statusInfo,
} from "../../../interfaces/defaultInterfaces";
import SystemApi from "../../../services/systemApi";

import { LoggedUser } from "../../../atoms/userLogged";
import jwt_decode from "jwt-decode";
import ModalSalesListDetail from "./components/modalSaleListDetail";

import { toast } from "react-toastify";
import DateDropdownDeafult from "../../../defaultComponents/dateDropdown";
import { customColors } from "../../../atoms/customColors";
import { dateForListWithHours } from "../../../constants/dataFormat";

interface PaymentMethod {
  id: string;
  resource: string;
  card_brand: string;
  first4_digits: string;
  last4_digits: string;
  expiration_month: string;
  expiration_year: string;
  holder_name: string;
  is_active: boolean;
  is_valid: boolean;
  is_verified: boolean;
  customer: string;
  fingerprint: string;
  address: string | null;
}

interface TransactionHistory {
  id: string;
  transaction: string;
  amount: string;
  operation_type: string;
  status: string;
  response_code: string | null;
  response_message: string | null;
  authorization_code: string | null;
  authorizer_id: string | null;
  authorization_nsu: string | null;
  gatewayResponseTime: string | null;
  authorizer: string | null;
  createdAt: string;
}

interface Transaction {
  id: string;
  resource: string;
  status: string;
  confirmed: string;
  amount: string;
  original_amount: string;
  currency: string;
  description: string | null;
  payment_type: string;
  transaction_number: string | null;
  gateway_authorizer: string | null;
  refunds: string | null;
  sales_receipt: string;
  on_behalf_of: string;
  customer: string;
  statement_descriptor: string | null;
  payment_method: PaymentMethod;
  voided: boolean;
  captured: boolean;
  paymentType: string;
  fees: string;
  statementDescriptor: string;
  expected_on: string;
  created_at: string;

  voided_at: string;
  point_of_sale: {
    entry_mode: string;
  };
  payment_authorization: {
    authorizer_id: string;
    authorization_code: string;
    authorization_nsu: string;
  };
  history: TransactionHistory[];
}

interface TransactionList {
  resource: string;
  uri: string;
  items: Transaction[];
  has_more: boolean;
  limit: number;
  total_pages: number;
  page: number;
  offset: number;
  total: string;
  query_count: string;
  description: string;
}

export interface JWTToken {
  primarysid: string;
  idTipoUsuario: string;
  name: string;
  email: string;
  exp: number;
  idCliente: number;
}

export default function SalesListDashboardTimeReal() {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [statusList, setStatusList] = useState<Transaction[]>([]);

  const [itemDetails, setItemDetails] = useState<
    Transaction | undefined | TransactionHistory
  >(undefined);
  const [isOpen, setIsOpen] = useState(false);
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const colors = useRecoilState(customColors)[0];
  const user = useRecoilState(LoggedUser)[0];
  const idUser = user.id;

  const [tempSearch, setTempSearch] = useState("");
  const getStatusText = (status: string) => {
    switch (status) {
      case "succeeded":
        return "Sucesso";
      case "pending":
        return "Pendente";
      case "failed":
        return "Falhou";
      case "new":
        return "Novo";
      case "chargeback":
        return "ChargeBack";
      case "canceled":
        return "Cancelado";
      case "reversed":
        return "Revertido";
      case "created":
        return "Criado";
      case "disputed":
        return "Disputa";
      default:
        return status || "N/A";
    }
  };
  const getTraducaoType = (status: string) => {
    switch (status) {
      case "debit":
        return "DÉBITO";
      case "credit":
        return "CRÉDITO";
      default:
        return status || "N/A";
    }
  };
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const navigate = useNavigate();
  const dataInicio = 0;
  const dataFim = 0;
  /*   const dataInicio = 1727740800;
  const dataFim = 1730419199; */
  const initialValues = {
    clientFilter: 0,
    statusFilter: 0,
    saleTypeFilter: 0,
    initialDateFilter: dataInicio,
    finalDateFilter: dataFim,
    minValueFilter: 0,
    maxValueFilter: 0,
  };
  const [filtros, setFiltros] = useState(initialValues);
  /*   console.log("Valor de search:", search);
  console.log("Valor do data:", dataInicio, dataFim); */
  async function getStatusList() {
    try {
      setLoading(true);
      const id = search ? search : null;

      let dataInicioTimestamp = 0;
      let dataFimTimestamp = 0;

      if (!id) {
        dataInicioTimestamp = moment(filtros.initialDateFilter).unix();
        dataFimTimestamp = moment(filtros.finalDateFilter).unix();
      }

      // Chamada para a API com limit (pageSize) e page (currentPage)
      const response: any = await SystemApi.getRealTime(
        Number(jwtToken.idCliente),
        id,
        dataInicioTimestamp,
        dataFimTimestamp,
        pageSize, // Passando o pageSize como limit
        currentPage // Passando currentPage para a API
      );

      if (response && typeof response === "object") {
        // Atualiza a lista de status
        setStatusList(
          Array.isArray(response.items) ? response.items : [response]
        );

        // Agora usa diretamente o total e total_pages da resposta
        const totalItems = response.total || 0; // Total de itens
        const totalPages = response.total_pages || 1; // Total de páginas

        setPages(totalPages); // Define diretamente o total de páginas
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  }

  const onChangeSize = (e: any) => {
    const newSize = e.target.value;
    setPageSize(newSize);
    setCurrentPage(1); // Reseta para a primeira página
  };

  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1);
      getStatusList();
    }
  }, [pages]);

  useEffect(() => {
    getStatusList();
  }, [
    search,
    currentPage,
    pageSize,
    filtros.statusFilter,
    filtros.saleTypeFilter,
    filtros.clientFilter,
    filtros.initialDateFilter,
    filtros.finalDateFilter,
    filtros.minValueFilter,
    filtros.maxValueFilter,
  ]);

  const setHeaderLocation = useSetRecoilState(componentState);
  useEffect(() => {
    setHeaderLocation("Lista de Vendas");
  }, []);

  // Atualizando a função para a nova rota com idCliente

  useEffect(() => {
    getStatusList();
  }, [
    search,
    currentPage,
    pageSize,
    filtros.statusFilter,
    filtros.saleTypeFilter,
    filtros.clientFilter,
    filtros.initialDateFilter,
    filtros.finalDateFilter,
    filtros.minValueFilter,
    filtros.maxValueFilter,
  ]);

  return (
    <Flex flexDir={"column"} height="100%" width="100%" bgColor={colors.WHITE}>
      <Box
        width={"100%"}
        height={"fit-content"}
        mt={"0.3%"}
        mx="auto"
        py={3}
        px={3}
      >
        <Flex px={8} py={3} alignItems="center">
          <FaPlay color={colors.BLUEMONEDDBUTTONS} size="25px" />
          <Text
            mx={4}
            color={colors.BLUEMONEDDBUTTONS}
            fontSize={35}
            fontWeight={"bold"}
          >
            Lista de Vendas (Tempo Real)
          </Text>
        </Flex>
      </Box>
      <Flex
        width={"100%"}
        height={"fit-content"}
        mt={"0.1%"}
        mx="auto"
        px={10}
        flexDirection={"column"}
      >
        <Text mb={1} fontWeight={"bold"}>
          Filtros
        </Text>
        <Flex
          width={"100%"}
          height={"100%"}
          justifyContent="space-evenly"
          mt={4}
          flexDirection={"column"}
        >
          <Flex py={3} w={"100%"} justifyContent="space-between">
            <DateDropdownDeafult filtros={filtros} setFiltros={setFiltros} />
            <InputGroup width={"30%"}>
              <Input
                placeholder="Buscar pelo ID da transação"
                value={tempSearch}
                onKeyDown={(e: any) => {
                  if (e.key === "Enter") {
                    setSearch(tempSearch);
                  }
                }}
                onChange={(e: any) => setTempSearch(e.target.value)}
              />
              <InputRightElement>
                <Button
                  onClick={() => {
                    setSearch(tempSearch);
                    setIsSearchClicked(true);
                  }}
                  leftIcon={<FaSearch />}
                />
              </InputRightElement>
            </InputGroup>

            <Button
              bgColor={colors.BLUEMONEDDBUTTONS}
              color={colors.WHITE}
              fontSize={"1.8vh"}
              onClick={() => {
                setFiltros(initialValues);

                setTempSearch("");
                setSearch("");
                setIsSearchClicked(false);
              }}
            >
              Limpar Filtros
            </Button>
          </Flex>
        </Flex>
      </Flex>
      <Box width={"100%"} height={"85%"} mt={"0.1%"} mx="auto" py={3} px={10}>
        {loading ? (
          <Flex
            w={"100%"}
            // h={"66vh"}
            alignItems={"center"}
            justifyContent={"center"}
            px={4}
            flexDirection="column"
          >
            <Spinner size={"lg"} color={colors.VARIANT} />
          </Flex>
        ) : (
          <TableContainer borderRadius="8px">
            <Table variant="striped" size="sm" overflowY="scroll">
              <Thead h="50px" position="sticky" top="0">
                <Tr>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Data
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    ID Transação
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Status
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Nome do Estabelecimento
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Tipo
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Valor Total
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {Array.isArray(statusList) && statusList.length > 0 ? (
                  statusList.map((item, index) => {
                    // Verificar condições específicas
                    const isContactlessOrChip =
                      item.point_of_sale?.entry_mode === "contactless_chip" ||
                      item.point_of_sale?.entry_mode === "chip";
                    const isSucceeded = item.status === "succeeded";
                    const confirmedStatus =
                      item.confirmed === "1"
                        ? "Sucesso"
                        : item.confirmed === "0"
                        ? "Pendente"
                        : "N/A";

                    return (
                      <Tr
                        key={index}
                        cursor="pointer"
                        onClick={() => {
                          setIsOpen(true);
                          setItemDetails(item);
                        }}
                      >
                        <Th>
                          {item.created_at
                            ? moment(item.created_at).format("DD/MM/YYYY HH:mm")
                            : "-"}
                        </Th>
                        <Th>{item.id || "-"}</Th>
                        <Th>
                          {isContactlessOrChip && isSucceeded
                            ? confirmedStatus
                            : getStatusText(item.status) || "N/A"}
                        </Th>
                        <Th>{item.statement_descriptor || "-"}</Th>
                        <Th>{getTraducaoType(item.payment_type)}</Th>
                        <Th>
                          {item.amount
                            ? parseFloat(item.amount).toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })
                            : "R$ 0,00"}
                        </Th>
                      </Tr>
                    );
                  })
                ) : (
                  <Tr>
                    <Th colSpan={6} textAlign="center">
                      Nenhum dado disponível
                    </Th>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>
        )}
        <ModalSalesListDetail
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          item={itemDetails}
        />
        <Flex width={"100%"} justifyContent="center" mt={8}>
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pages={pages}
            pageSize={pageSize}
          />
          <Select
            value={pageSize}
            onChange={onChangeSize}
            size="sm"
            ml={5}
            maxW="70px"
            borderRadius="6px"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={25}>25</option>
          </Select>
        </Flex>
      </Box>
    </Flex>
  );
}
